import React, { PureComponent } from 'react';
import PT from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import denseIcon from '../../../../assets/images/density-jammed2x.png';
import spreadIcon from '../../../../assets/images/density-comfy2x.png';
import {
  selectControlsState,
  collapseTables,
  expandTables,
} from '../../../../store/reducers/tableControls';
import classes from './DataDensity.css';

const mapStateToProps = state => ({
  collapsed: selectControlsState(state).collapsed,
});
const actions = {
  onCollapse: collapseTables,
  onExpand: expandTables,
};
export class DataDensity extends PureComponent {
  static propTypes = {
    collapsed: PT.bool.isRequired,
    onCollapse: PT.func.isRequired,
    onExpand: PT.func.isRequired,
  }

  render = () => {
    const { collapsed } = this.props;

    const collapsedClass = isMe => classNames(
      classes.iconButton,
      { [classes.dim]: (collapsed === isMe) },
    );

    return (
      <div className={classes.wrapper}>
        Data Density
        <button
          className={collapsedClass(true)}
          onClick={this.props.onExpand}
        >
          <img alt="Spread" src={spreadIcon} />
        </button>
        <button
          className={collapsedClass(false)}
          onClick={this.props.onCollapse}
        >
          <img alt="Dense" src={denseIcon} />
        </button>
      </div>
    );
  }
}
export default connect(mapStateToProps, actions)(DataDensity);



// WEBPACK FOOTER //
// ./src/app/components/TableControls/DataDensity/DataDensity.js